var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('project-overview-header'),_vm._l((_vm.orderBy(_vm.filterBy(_vm.projects, _vm.searchstring, 'customer', 'projectName'), 'customer')),function(project){return _c('project-overview',{key:project.timesheetId,attrs:{"line":project}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }